import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'Components/atoms'
import { setModalProviderOpen } from 'Redux/purchases/actions'

import Provider from '../providerDetail'

const ModalProvider = () => {
  const isOpen = useSelector(state => state.purchase.modalProviderOpen)
  const dispatch = useDispatch()

  const setIsOpen = value => dispatch(setModalProviderOpen(value))

  return (
    <Modal
      providerDetail
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      displayContainer='initial'
      justifyContainer='initial'
      margin='0 auto'
      width='57.5rem'
      height='auto'
      padding='2.5rem 5rem'
      textAlign='left'
    >
      <Provider />
    </Modal>
  )
}

export default ModalProvider
